import { ButtonLink } from "@ui/ButtonLink";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { signInUrl } from "~/modules/shared/utils/auth";
import { pageVars } from "../pageVars";
import "./ConsumerMenuFooter.css";
import { UserPanel } from "@ui/organisms/UserPanel/UserPanel";

const CreatorCta = () => (
	<ButtonLink
		href="/studio"
		variant="secondary"
		symbol={["grid_view", "open_in_new"]}
		fullWidth
		class="menu-footer-creator"
	>
		Are you a creator?
	</ButtonLink>
);

/** Same structure as {@link MenuFooter} for the AskGVT `askgvt` variant. */
export const ConsumerMenuFooter = () => {
	const vars = pageVars();

	return (
		<div
			class="menu-footer"
			classList={{ "menu-footer--in-flow": !vars.isSignedIn }}
		>
			<Show
				when={vars.isSignedIn}
				fallback={
					<section class="user askgvt1-menu-footer-guest">
						<VStack spacing="large">
							<CreatorCta />
							<Text size="xsmall" color="fg3">
								Sign up to keep your answers and ask across every creator you
								subscribe to.
							</Text>
							<HStack spacing="medium" fullWidth>
								<ButtonLink href={signInUrl()} variant="tertiary" fullWidth>
									Log in
								</ButtonLink>
								<ButtonLink
									href={signInUrl()}
									variant="primary"
									theme="mint-grad"
									fullWidth
								>
									Sign up free
								</ButtonLink>
							</HStack>
						</VStack>
					</section>
				}
			>
				<section class="user">
					<UserPanel
						referrer="askgvt"
						user={{
							userName: vars.userName ?? "",
							userEmail: vars.userEmail ?? "",
							userAvatar: vars.user_avatar ?? vars.userAvatar ?? "",
							influencerHandle: vars.user_handle ?? vars.influencerHandle ?? "",
						}}
					/>
				</section>
			</Show>
		</div>
	);
};
